import React, { FC } from 'react';
import { usePage } from '@montana/containers/page';
import { Link } from '../link';

export const Breadcrumbs: FC = () => {
    const { breadcrumb, name } = usePage();

    return (
        <nav className="breadcrumbs">
            { breadcrumb && breadcrumb.length > 1 &&
                <ol>
                    {breadcrumb?.slice(1).map((b, i) => (
                        <li key={`breadcrumb__${b.name}__${i}`} className="breadcrumbs__crumb">
                            <Link withStroke inverseStrokeAnimation className="breadcrumbs__crumb-link" to={b.url} insametab>{b.name}</Link>
                        </li>
                    ))}
                    <li key={`breadcrumb__${name}__final`} className="breadcrumbs__crumb">{name}</li>
                </ol>
            }
        </nav>
    );
}
